import Papa from "papaparse";
import dayjs from "dayjs";
import { Option } from "../../components/select/Select";

export const getNumber: (str: string | number) => number = str =>
  Number(String(str).replace(/[^\d.]/g, "")) || 0;

export const parseCSV: (file: File) => Promise<any[]> = file =>
  new Promise(resolve => {
    Papa.parse<File>(file, {
      complete: ({ data }) => resolve(data),
      worker: true,
      header: true
    });
  });

export const getOptionsFromArray: (strArray: string[] | number[]) => Option[] =
  strArray => {
    return strArray.map(str => ({ label: str, value: str }));
  };

export const getQueryParams: (params: Record<string, any>) => string =
  params => {
    const processedParams = Object.entries(params).reduce(
      (obj, [key, value]) =>
        value === undefined || value === null
          ? obj
          : { ...obj, [key]: String(value) },
      {}
    );
    return new URLSearchParams(processedParams).toString();
  };

export const getFormattedDateTime: (legacyDateTime: number[]) => string =
  legacyDateTime => {
    return legacyDateTime
      ? dayjs(
          new Date(
            legacyDateTime[0],
            legacyDateTime[1] - 1,
            legacyDateTime[2],
            legacyDateTime[3] || 0,
            legacyDateTime[4] || 0,
            legacyDateTime[5] || 0
          )
        ).format("D MMM YYYY, h:mm A")
      : "";
  };
